export default __webpack_public_path__ + "static/media/0b86d2ba3a567e352f1293e107a2bce31581619433423.3c8ff8fd.webp";